import { useEffect } from 'react';

import type { UseBrandsEffectsProps } from '@app/pages/Warehouses/Brands/types';

export const useBrandsEffects = ({
  onSearchHandler,
}: UseBrandsEffectsProps) => {
  useEffect(() => {
    onSearchHandler();
  }, [onSearchHandler]);
};
